import Firstsection from "../sections/firstSection";
import About from "../sections/about";
import Tokenomics from "../sections/tokenomics";
import Supply from "../sections/supply";
import Footer from "../sections/footer";


function Home() {
    return (
        <>
            <Firstsection />
            <About />
            <Tokenomics />
            <Supply />
            <Footer />
        </>
    );
}

export default Home;